import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#3C3C3C] group-[.toaster]:border-[#DCDCDC] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#737373]",
          actionButton:
            "group-[.toast]:bg-[#FF7819] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#F2F2F2] group-[.toast]:text-[#737373]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
